import actions from './actions';

export const reset = () => ({ type: actions.RESET });
export const unbusyAll = () => ({ type: actions.UNBUSY });
